<div class="flex justify-center">
  <div
    class="w-full px-2 sm:px-4 lg:p-0"
    [ngClass]="[
    maxWidth ? maxWidth : 'max-w-[768px]',
    marginTop ? marginTop : 'mt-4 md:mt-16'
    ]"
  >
    @switch (size) {
      @case (PageSize.SINGLE) {
        <ng-content/>
      }
      @case (PageSize.HALF) {
        <ng-content select="[top]"/>
        <div class="flex flex-col lg:flex-row">
          <div class="lg:basis-1/2" [ngClass]="{'max-lg:order-last': rightFirstOnMobile, 'max-lg:order-first': !rightFirstOnMobile}">
            <ng-content select="[left]"/>
          </div>
          <div class="lg:basis-1/2" [ngClass]="{'max-lg:order-first': rightFirstOnMobile, 'max-lg:order-last': !rightFirstOnMobile}">
            <ng-content select="[right]"/>
          </div>
        </div>
      }
      @case (PageSize.TWO_THIRD) {
        <div class="flex">
          <div class="lg:pr-8 lg:basis-2/3">
            <ng-content select="[left]"/>
          </div>
          <div class="pl-8 lg:basis-1/3 max-lg:hidden">
            <ng-content select="[right]"/>
          </div>
        </div>
      }
    }
  </div>
</div>
